import { Navigate } from 'react-router-dom';
import { useEstablishmentStore } from '../store/establishment';

interface PrivateRouteProps {
  children: React.ReactNode;
}

export function PrivateRoute({ children }: PrivateRouteProps) {
  const { establishment, loading } = useEstablishmentStore();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
      </div>
    );
  }

  if (!establishment) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}